import {
  QrCodeScannerRounded,
  AddRounded,
  FilterListRounded,
} from "@mui/icons-material";
import { Box, Fab } from "@mui/material";
import { useInventory } from "../../../InventoryProvider";
import { Dispatch, FC, SetStateAction, useState } from "react";
import FilterDialogPhone from "./FilterDialogPhone";
import { InventoryData } from "../../../../../types/inventoryData";
import { useTranslation } from "react-i18next";

type ToolbarPhoneTypes = {
  popupToggles: {
    history: boolean;
    addProduct: boolean;
    batchEdit: boolean;
    ganttChart: boolean;
    batchQrScannerToggle: boolean;
    batchEditMode: boolean;
  };
  setPopupToggles: React.Dispatch<
    React.SetStateAction<{
      history: boolean;
      addProduct: boolean;
      batchEdit: boolean;
      ganttChart: boolean;
      batchQrScannerToggle: boolean;
      batchEditMode: boolean;
    }>
  >;
  setQrScannerToggle: Dispatch<SetStateAction<boolean>>;
  selectedRows: InventoryData[];
};

const ToolbarPhone: FC<ToolbarPhoneTypes> = ({
  popupToggles,
  setPopupToggles,
  setQrScannerToggle,
  selectedRows,
}) => {
  const { setSelectedProductIds } = useInventory();
  const { t } = useTranslation();

  const [phoneFilterDialog, setPhoneFilterDialog] = useState<boolean>(false);
  const [phoneFilterOpen, setPhoneFilterOpen] = useState<
    Record<string, boolean>
  >({});

  const handleToggle = (id: string) => {
    setPhoneFilterOpen((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  return (
    <Box
      sx={{
        "& > :not(style)": { m: 1 },
        position: "fixed",
        bottom: 32,
        left: 0,
        // right: 32,
        width: "100%",
        display: "flex",
        justifyContent: "center",
        margin: "auto auto",
        zIndex: 1,
      }}
    >
      <Fab
        aria-label="searchQr"
        color="default"
        size="medium"
        onClick={() => setQrScannerToggle(true)}
      >
        <QrCodeScannerRounded />
      </Fab>

      <Fab
        variant="extended"
        aria-label="add"
        color="default"
        onClick={() => setPopupToggles({ ...popupToggles, addProduct: true })}
      >
        <AddRounded />
        {t("inventory.add")}
      </Fab>

      {/* <Fab
        variant="extended"
        aria-label="batchEdit"
        color="default"
        disabled={selectedRows.length > 1 ? false : true}
        onClick={() => {
          setSelectedProductIds(selectedRows.map((r) => r.productId));
          setPopupToggles({ ...popupToggles, batchEdit: true });
        }}
      >
        {t("inventory.batchEdit")}
      </Fab> */}

      <Fab
        variant="extended"
        color="default"
        onClick={() => {
          setPopupToggles({ ...popupToggles, batchEdit: true });
          if (selectedRows.length > 1)
            setSelectedProductIds(selectedRows.map((r) => r.productId));
        }}
      >
        {t("inventory.batchEdit")}
      </Fab>

      <Fab
        aria-label="filter"
        color="default"
        size="medium"
        onClick={() => {
          setPhoneFilterDialog(true);
        }}
      >
        <FilterListRounded />
      </Fab>

      <FilterDialogPhone
        phoneFilterOpen={phoneFilterOpen}
        phoneFilterDialog={phoneFilterDialog}
        setPhoneFilterDialog={setPhoneFilterDialog}
        handleToggle={handleToggle}
      />
    </Box>
  );
};

export default ToolbarPhone;
